var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0464 0.325212C27.2122 4.01365 8.23417 14.2542 1.42569 17.9277C0.508665 18.4228 -0.0434419 19.3968 0.00268048 20.4373C0.0501594 21.4764 0.687722 22.3989 1.64408 22.8085L10.8387 26.7547L10.794 32.5214C10.7845 33.6432 11.4682 34.6566 12.514 35.0663C13.5586 35.4773 14.7496 35.2019 15.5079 34.3744L19.3917 30.1312L29.2904 33.4072C30.0338 33.6541 30.8491 33.5659 31.5233 33.1657C32.1988 32.7669 32.6682 32.0954 32.8106 31.3236L38.0021 3.2065C38.192 2.17959 37.7756 1.13507 36.9318 0.519205C36.0867 -0.0953086 34.9648 -0.169926 34.0464 0.325212ZM34.9146 4.99035L30.1423 30.8311L19.4107 27.2797C18.9034 27.1115 18.3445 27.258 17.9836 27.6514L13.5071 32.5417L13.5545 26.4278L34.9146 4.99035ZM2.71305 20.3152L11.8914 24.2533L31.0485 5.02562L2.71305 20.3152Z",
    fill: "#FFA5E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a6bc4d28d2013424a7c780d297a3b751.svg";
export { ForwardRef as ReactComponent };